import SedeDetalle from './sedeDetalle';

class ProductoSedes extends React.Component {
    constructor() {
        super();
        this.state = {
            productsActiveKey: 0
        };
        this.loadLocation = this.loadLocation.bind(this);
    }

    componentDidMount() {
        
    }

    loadLocation(productsActiveKey) {
        if (productsActiveKey) {
            const product = this.props.product;
            const service = product.services[productsActiveKey-1];
            const location = service.location;
            const pnpService = new ServicioPnp();
            pnpService.getList('saludSedes', (items) => {
                if (items.length > 0) {
                    pnpService.getItemAsHtml(items[0].ID, 'saludSedes', (item) => {
                        location.name = item.CSNombreSedeText;
                        location.description = item.CSNotasNote;
                        location.address = item.CSDireccionText;
                        location.phone = item.CSTelefonoText;
                        location.schedule = item.CSHorarioNote;
                        location.parking = item.CSParqueaderoNote;
                        location.zone = item.CSSaliRedZonaChoise;
                        location.image = item.CSImagen;
                        if (item.CSImagen) location.imgSrc = /<img.*?src="(.*?)"/.exec(item.CSImagen)[1];
                        location.lat = parseFloat(item.CSLatitudText);
                        location.lng = parseFloat(item.CSLongitudText);
                        service.loading = false;
                        if (this.props.specialityIndex != null) {
                            this.props.updateProductsState(product, this.props.productIndex, this.props.specialityIndex);
                        } else {
                            this.props.updateProductsState(product, this.props.productIndex);
                        }
                    });
                }
            }, "CSCodigoSedeNumber eq '" + service.code + "'");
        }
        this.setState({ productsActiveKey });
    }

    renderServices(services) {
        return services.map((service, index) => {
            return (
                <Panel eventKey={service.id} key={service.id}>
                    <Panel.Heading>
                        <Panel.Title toggle>
                            <h5 className={( this.state.productsActiveKey-1 == index ? 'active-title' : 'inactive-title')}>{service.name}</h5>
                            <div className={ 'accordion-icon ' + (this.state.productsActiveKey-1 == index ? 'active' : '' )}>
                                <i className={ 'fa ' + ( this.state.productsActiveKey-1 == index ? 'fa-chevron-circle-up' : 'fa-chevron-circle-down')}></i>
                            </div>
                        </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body collapsible>
                        { !service.loading ? (
                        <SedeDetalle location={service.location} />
                        ) : '' }
                    </Panel.Body>
                </Panel>
            );
        });
    }
    
    render() {
        return (
            <div>
            {
                this.props.product.services.length > 0 ? 
                <PanelGroup accordion id={'product-accordeon-' + this.props.productIndex} activeKey={this.state.productsActiveKey} onSelect={this.loadLocation}>
                    { this.renderServices(this.props.product.services) }
                </PanelGroup>
                :
                <p className="no-info">No hay información</p>
            }  
            </div>
        );
    }
}
/******************** BUILD ********************/
const PanelGroup = ReactBootstrap.PanelGroup;
const Panel = ReactBootstrap.Panel;
/******************** BUILD ********************/

export default ProductoSedes;



// WEBPACK FOOTER //
// ./salidaGraficaRed/miRedDeAtencion/otrosServiciosRedDeUrgencias/src/components/productoSedes.js